import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import style from "../stopInfoSquare/components/StopInfoTableSquare.module.css";
import { getBusStopInfoService } from "../../services/commonservices";
import {
  BUS_LINES_LIMIT,
  STOP_INFO_COLUMNS,
  STOP_SERVICE_REFRESH_TIME,
} from "../stopInfo/stopInfoConstants";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { useIntl } from "react-intl";
import StopInfoTableSquare from "./components/StopInfoTableSquare";
import { H_4 } from "../../utils/constants";
import { COMMON__NO_LINE_INFORMATION } from "../../translations/constans";
import { makeStyles } from "@mui/styles";
import styles from "../../components/landing/LoginStyles";

const useStyles = makeStyles((theme) => styles(theme));

const StopInfoComponentSquare = ({ stopId }) => {
  const { id } = useParams();
  const intl = useIntl();
  const classes = useStyles();

  let interval = null;

  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const busInfoCallback = (response) => {
    if (!response.data?.routes?.length) {
      setRows([]);
      return;
    }

    const routes = response.data?.routes?.map((route) => {
      return {
        arrival_time:
          route.bus?.arrival_time === null
            ? "Fuera de servicio"
            : `${route.bus?.arrival_time} min`,
        destiny: route.destiny,
        current_location: route.bus?.current_location,
          is_real_time: route?.bus?.is_real_time,
          estimated_arrival_time: route?.bus?.estimated_arrival_time,

      };
    });
    setIsLoading(false);
    setRows(routes);
  };

  useEffect(() => {
    const headers = { "X-Request-Origin": "stop-square" };
    getBusStopInfoService(
      id ?? stopId,
      BUS_LINES_LIMIT,
      busInfoCallback,
      headers
    );
    interval = setInterval(() => {
      getBusStopInfoService(
        id ?? stopId,
        { max_num_routes: 5 },
        busInfoCallback,
        headers
      );
    }, STOP_SERVICE_REFRESH_TIME);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={style.containerDark}>
      {!isLoading && (
        <section className={style.table}>
          <StopInfoTableSquare
            rows={rows}
            columns={STOP_INFO_COLUMNS}
          />
        </section>
      )}
      {isLoading ? (
        <section>
          <div className={style.table}>
            <div className={style.scrollable} data-testid="scrollable-div">
                <Typography className={classes.loadingTitle} variant={H_4}>
                {intl.formatMessage({ id: COMMON__NO_LINE_INFORMATION })}
            </Typography>
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
    </div>
  );
};

StopInfoComponentSquare.propTypes = {
  stopId: PropTypes.number,
};

StopInfoComponentSquare.defaultProps = {
  stopId: undefined,
};

export default StopInfoComponentSquare;
